import { getResourceTo } from 'react/utils/utils';

/**
 * Factory function to create stop action menu items
 *
 * @param {Object} stopActions - The actions from useStopActions hook
 * @param {Object} stop - The stop object
 * @param {Function} toggleOrderAndItemsModal - Function to toggle orders and items modal
 * @param {Object} permissions - Permission flags from useStopActionsMenuPermissions
 * @param {Object} stopState - The current state of the stop (e.g. allowArriveItem, allowDepartStop)
 * @returns {Array} Array of menu items
 */
export const createStopMenuItems = (
  stopActions,
  toggleOrderAndItemsModal,
  permissions,
  stopState
) => {
  const menus = [];
  const {
    allowArriveItem,
    allowDepartStop,
    allowUndeliveryStop,
    allowSeeOrdersAndItems
  } = stopState;
  const {
    canViewStopDetails,
    canArriveAtStop,
    canCancelStop,
    canDepartFromStop,
    canMarkUndeliverable,
    canMarkForRedelivery
  } = permissions;

  const addMenuItem = (condition, menuItem) => {
    if (condition) {
      menus.push(menuItem);
    }
  };

  addMenuItem(canViewStopDetails, {
    iconClass: 'MonetUIMenuRouteIcon viewRouteDetails',
    name: getResourceTo('modal.stopdetails.view.stop.details'),
    type: 'view-stop-details',
    onClick: stopActions.navigateToStopDetails
  });

  addMenuItem(allowSeeOrdersAndItems, {
    iconClass: 'MonetUIMenuRouteIcon viewOrdersAndItems',
    name: getResourceTo('modal.stopdetails.view.ordersanditens'),
    type: 'view-orders-and-items',
    onClick: toggleOrderAndItemsModal
  });

  addMenuItem(canArriveAtStop && allowArriveItem, {
    iconClass: 'MonetUIMenuRouteIcon arriveStop',
    name: getResourceTo('modal.stopdetails.ArriveStop'),
    type: 'arrive-stop',
    onClick: stopActions.arriveAtStop
  });

  addMenuItem(canCancelStop && allowArriveItem, {
    iconClass: 'MonetUIMenuRouteIcon cancelStop',
    name: getResourceTo('Greenmile.Route.ArriveDestination.PendingStops.btnSave'),
    type: 'cancel-stop',
    onClick: stopActions.cancelStop
  });

  addMenuItem(canDepartFromStop && allowDepartStop, {
    iconClass: 'MonetUIMenuRouteIcon departStop',
    name: getResourceTo('Greenmile.Stop.Depart.btnSave'),
    type: 'depart-stop',
    onClick: stopActions.departFromStop
  });

  addMenuItem(canMarkUndeliverable && allowUndeliveryStop, {
    iconClass: 'MonetUIMenuRouteIcon returnStop',
    name: getResourceTo('event.check.undeliverablestop'),
    type: 'undelivery-stop',
    onClick: stopActions.markAsUndeliverable
  });

  addMenuItem(canMarkForRedelivery && allowUndeliveryStop, {
    iconClass: 'MonetUIMenuRouteIcon undeliverableStop',
    name: getResourceTo('stop.redeliveryStop'),
    type: 'redelivery-stop',
    onClick: stopActions.markForRedelivery
  });
  return menus;
};
